export default [
  "new",
  "working",
  "nurturing",
  "unqualified",
  "qualified",
  "high_opp",
  "graduated",
];
